import React, { Component } from 'react';
import v from 'vudu';
import { styles as s, colors, breakpoints } from 'stylesheet';
import copy from 'constants/copy';
import OptionInput from 'components/OptionInput';
import Arrow from 'components/svgs/Arrow';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { submitEmail } from 'state/actions/homeActions';
import { Status } from 'state/reducers/statusReducer';
import get from 'utils/get';
import SegmentWrapper from 'lib/segment';

function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

const localClasses = v({
  emailForm: {
    '@composes': [s.relative],
    maxWidth: '380px',
    margin: 'auto',
    [breakpoints.lg]: {
      '@composes': [s.pl3],
      margin: 'inherit'
    },
  },
  fixedVariant: {
    'input': {
      color: 'white',
      backgroundColor: 'rgba(255, 255, 255, 0.11)',
      '::placeholder': {
        color: 'rgba(255, 255, 255, 0.75)'
      }
    }
  },
  expand: {
    maxWidth: 'unset',
    paddingLeft: 0
  },
  input: {
    '@composes': [s.black],
    padding: '19px 16px 16px 16px',
    backgroundColor: 'white',
    borderRadius: '6px',
    border: 'none',
    outline: 'none',
    width: '100%',
    fontSize: '14px',
    '::placeholder': {
      color: 'rgba(0, 0, 0, 0.75)'
    }
  },
  optionLink: {
    color: colors.white,
    textDecoration: 'none',
    fontWeight: 600,
    ':hover': {
      color: colors.byzantine
    }
  },
  submit: {
    '@composes': [s.absolute, s.r0, s.t0, s.mr2],
    marginTop: '9.5px',
    outline: 'none',
    backgroundColor: colors.razzmatazz,
    border: 'none',
    padding: '9px 11px',
    borderRadius: '999px',
    display: 'flex',
    backgroundImage: `linear-gradient(220deg, ${colors.razzmatazz} 0%, ${colors.byzantine} 100%)`,
    boxShadow: '0 2px 15px 0 rgba(247,37,107,0.37)'
  },
  submitInactive: {
    opacity: 0.5,
  },
  checkbox: {
    '@composes': [s.pt2],
    [breakpoints.lg]: {
      '@composes': [s.pl3],
    }
  },
  checkboxFixed: {
    opacity: 0,
    pointerEvents: 'none',
    textAlign: 'left',
    borderRadius: '6px',
    backgroundColor: 'white',
    position: 'absolute',
    padding: '10px 10px 14px 10px',
    top: '63px',
    ':after': {
      content: '""',
      position: 'absolute',
      width: '2px',
      height: 0,
      borderWidth: '8px',
      borderStyle: 'solid',
      borderColor: `transparent transparent white transparent`,
      top: '-16px',
      left: '10%'
    }
  },
  checkboxFixedActive: {
    opacity: 1,
    pointerEvents: 'auto',
  },
  tooltip: {
    '@composes': [s.p1, s.white],
    fontFamily: 'AvenirLTStd-Heavy, sans-serif',
    position: 'absolute',
    fontSize: '13px',
    transform: 'translateY(-100%)',
    transition: 'all 200ms ease-out',
    top: '-14px',
    backgroundColor: colors.razzmatazz,
    borderRadius: '4px',
    opacity: 0,
    ':after': {
      content: '""',
      position: 'absolute',
      width: '2px',
      height: 0,
      borderWidth: '8px',
      borderStyle: 'solid',
      borderColor: `${colors.razzmatazz} transparent transparent transparent`,
      top: '100%',
      left: '50%',
      transform: 'translateX(-50%)'
    }
  },
  reverseTooltip: {
    '@composes': [s.p1, s.white],
    fontFamily: 'AvenirLTStd-Heavy, sans-serif',
    fontSize: '13px',
    position: 'absolute',
    transition: 'all 200ms ease-out',
    backgroundColor: colors.razzmatazz,
    borderRadius: '4px',
    bottom: '-50px',
    opacity: 0,
    ':after': {
      content: '""',
      position: 'absolute',
      width: '2px',
      height: 0,
      borderWidth: '8px',
      borderStyle: 'solid',
      borderColor: `transparent transparent ${colors.razzmatazz} transparent`,
      top: '-14px',
      left: '50%',
      transform: 'translateX(-50%)'
    }
  },
  tooltipActive: {
    opacity: 1
  }
});

const Tooltip = props => {
  let classes = localClasses.tooltip;
  if (props.fromBottom) classes = localClasses.reverseTooltip;
  let active = !!props.message;
  if (active) classes = `${classes} ${localClasses.tooltipActive}`;
  return (
    <div className={classes}>
      {capitalizeFirstLetter(props.message || "")}
    </div>
  );
};

class EmailForm extends Component {
  constructor(props) {
    super(...arguments);
    this.state = {
      email: get(props, 'initialValue', ''),
      hasAgreedToTerms: false,
      tooltip: null
    }
  }

  componentWillReceiveProps(nextProps) {
    let error = get(nextProps, 'error.errors', [])[0];
    if (error) this.setState({ tooltip: error.detail });
  }

  inputDidChange = (e) => {
    SegmentWrapper.didStartSignup(this.props.position);
    let emailConsideredValid = (!!/(.+)@(.+){1,}\.(.+){1,}/.test(e.target.value));
    this.setState({ email: e.target.value, emailConsideredValid });
    if (!!this.state.tooltip) this.setState({ tooltip: null });
  }

  formDidSubmit = (e) => {
    e.preventDefault();

    if (!this.state.emailConsideredValid)
      return this.setState({ tooltip: copy.emailFormComponent.tooltips.invalidEmail });

    if (!this.state.hasAgreedToTerms)
      return this.setState({ tooltip: copy.emailFormComponent.tooltips.terms });

    if (get(this, 'props.status') === Status.PENDING) return;

    this.props.actions.submitEmail(this.state.email, this.props.position);
  }

  didClickTerms = () => {
    SegmentWrapper.didAcceptTerms(this.props.position);
    this.setState({
      hasAgreedToTerms: !this.state.hasAgreedToTerms,
      tooltip: null
    });
  }

  render() {
    let wrapper = localClasses.emailForm;
    if (this.props.isFixed) wrapper += ` ${localClasses.fixedVariant}`;
    if (this.props.expand) wrapper += ` ${localClasses.expand}`;

    let checkboxClasses = this.props.isFixed ? localClasses.checkboxFixed : localClasses.checkbox;
    if (this.state.emailConsideredValid && this.props.isFixed) checkboxClasses += ` ${localClasses.checkboxFixedActive}`;
    return (
      <form className={wrapper} onSubmit={this.formDidSubmit}>
        <Tooltip message={this.state.tooltip} fromBottom={this.props.isFixed} />
        <input
          className={localClasses.input}
          value={this.state.email}
          onChange={this.inputDidChange}
          placeholder={copy.emailFormComponent.placeholder}
        />
        <button className={this.state.hasAgreedToTerms ? localClasses.submit : `${localClasses.submitInactive} ${localClasses.submit}`}>
          <Arrow />
        </button>
        <div className={checkboxClasses}>
          <OptionInput
            checked={this.state.hasAgreedToTerms}
            onClick={this.didClickTerms}
            renderAsTooltip={this.props.isFixed}
          >
            I humbly accept the <Link className={localClasses.optionLink} to='/terms' target='_blank'>terms & conditions</Link>
          </OptionInput>
        </div>
      </form>
    )
  }
};

function mapStateToProps(state) {
  return {
    status: state.statusState.submitEmail,
    error: state.errorState.submitEmail,
    initialValue: state.applicationState.initialEmailValue
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        submitEmail
      },
      dispatch,
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(EmailForm);



// WEBPACK FOOTER //
// ./src/components/EmailForm.js